<script>

export default {
	data() {
		return {
			_recommended: false
		}
	},
	computed: {
		provider() {
			return this.$store.getters['providers/selectedProvider']
		}
	},
	methods: {
		recommended(provider, product) {
			if(provider.slug === 'vuma-reach-prepaid' && (product.speed_up === 10 && product.speed_down === 20)) {
				return this._recommended = true;
			}
		}
	}
}
</script>

<template>
	<div class="packages-box">
		<div class="box-header-column --heading">
			<h4>All {{ provider.name }} Packages</h4>
		</div>
		<div class="box-header-column --logo">
			<svg class="provider-logo"><use :href="`#provider-${provider.slug}`"></use></svg>
		</div>
		<div class="box-body-column --cards package-cards">
			<div class="package-card" v-for="p in provider.products" :class="{'recommended': recommended(provider, p)}">
				<dl class="card-header">
					<dt>R{{ p.price }}</dt>
					<dd>{{ provider.meta.additional_meta.included_days }} day topup included</dd>
				</dl>
				<dl class="card-footer">
					<dt>
						<svg><use href="#speed-down"></use></svg>
						<p>{{ p.speed_down }}Mbps</p>
					</dt>
					<dd>
						<svg><use href="#speed-up"></use></svg>
						<p>{{ p.speed_up }}Mbps</p>
					</dd>
				</dl>
			</div>
		</div>
		<div class="box-body-column --meta">
			<div class="provider-meta-card">
				<dl>
					<dt>{{ provider.meta.additional_meta.included_days }} Day internet access.</dt>
					<dd>Included with your Fibre installation.</dd>
				</dl>
				<span class="icon"></span>
			</div>
			<div class="provider-meta-card">
				<dl>
					<dt>Top up as needed. <sup>1</sup></dt>
					<dd>{{ provider.meta.additional_meta.topup_days }}</dd>
				</dl>
				<span class="icon"></span>
			</div>
			<div class="provider-meta-card">
				<dl>
					<dt>Shaping and prioritisation. <sup>2</sup></dt>
					<dd>{{ provider.meta.additional_meta.shaping_term }}</dd>
				</dl>
				<span class="icon"></span>
			</div>
			<div class="provider-meta-card">
				<dl>
					<dt>Payment method. <sup>3</sup></dt>
					<dd>{{ provider.meta.additional_meta.payment_method_term }}</dd>
				</dl>
				<span class="icon"></span>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
	.packages-box {
		margin-top: 4rem;
	}
</style>
